<div *ngIf="!submitted || submitting">
    <H1>User Security Information</H1>
    <b>(Complete One Per Person/Per Company)</b>
    <form #form="ngForm">
        <div fxLayout="column">           
            <mat-card>
                <mat-card-title>Action Requested</mat-card-title>
                <mat-card-content>
                    <cad-lib-radio 
                    matTooltip
                    [resultProperty]="'code'"
                    [displayProperty]="'description'"
                    [data]="actionOptions"
                    [(selectValue)]="data.actionCd"
                    fxFlex></cad-lib-radio>   
                </mat-card-content>
            </mat-card>

            <mat-card>
                <mat-card-title>Company Information</mat-card-title>
                <mat-card-content>
                    <div fxFlex fxLayout="column">
                        <div fxFlex col-span="2">
                            <mat-form-field fxFlex>
                                <mat-label>Company Name</mat-label>
                                <input matInput
                                [(ngModel)]="data.companies[0].companyName"
                                name="companyName"
                                required
                                maxlength="120"
                                />
                            </mat-form-field>
                        </div>
                        <mat-checkbox matInput name="primaryCompanyInd" [(ngModel)]="data.primaryCompanyInd" *ngIf="data.actionCd!='remove'">
                            <b>Check this box if the company named above is the primary company for which the User transacts business. Otherwise, please provide the name of the User's primary company below:</b>
                        </mat-checkbox>
                        <div fxFlex col-span="2" *ngIf="data.actionCd!='remove'">
                            <mat-form-field fxFlex>
                                <mat-label>Primary Company</mat-label>
                                <input matInput
                                [(ngModel)]="data.primaryCompany"
                                name="primaryCompany"
                                [required]="!data.primaryCompanyInd"
                                [disabled]="data.primaryCompanyInd"
                                maxlength="120"
                                />
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
            <mat-card>
                <mat-card-title>User Information</mat-card-title>
                <mat-card-content>
                <div fxFlex fxLayout="column">
                    <div fxFlex col-span="2" fxLayout="column" *ngIf="data.actionCd!='add'" >
                        <mat-form-field>
                            <mat-label>Messenger User ID</mat-label>
                            <input matInput
                            [(ngModel)]="data.userId"
                            name="userId"
                            required
                            />
                        </mat-form-field>
                    </div>
                    
                    <div fxFlex fxLayoutAlign="space-around center" fxLayoutGap="1em">
                        <mat-form-field fxFlex>
                            <mat-label>First Name</mat-label>
                            <input matInput
                            [(ngModel)]="data.firstName"
                            name="firstName"
                            minlength="2"
                            maxlength="30"
                            required
                            />
                        </mat-form-field>
                        <mat-form-field fxFlex>
                            <mat-label>Last Name</mat-label>
                            <input matInput
                            [(ngModel)]="data.lastName"
                            name="lastName"
                            minlength="2"
                            maxlength="30"
                            required
                            />
                        </mat-form-field>
                    </div>
                    <div fxFlex col-span="2" fxLayout="column" *ngIf="data.actionCd!='remove'">
                        <mat-form-field>
                            <mat-label>Title</mat-label>
                            <input matInput
                            [(ngModel)]="data.title"
                            name="title"
                            required
                            />
                        </mat-form-field>
                    </div>
                    <div fxFlex fxLayoutAlign="space-around center" fxLayoutGap="1em" *ngIf="data.actionCd!='remove'">
                        <mat-form-field fxFlex>
                            <mat-label>Email</mat-label>
                            <input matInput
                            emailAddress
                            [(ngModel)]="data.email"
                            name="email"
                            required
                            />
                        </mat-form-field>
                        <mat-form-field fxFlex="25">
                            <mat-label>Ice IM</mat-label>
                            <input matInput
                            [(ngModel)]="data.imId"
                            name="imId"
                            />
                        </mat-form-field>
                        <mat-form-field fxFlex>
                            <mat-label>Phone</mat-label>
                            <input matInput
                            [(ngModel)]="data.phone"
                            name="phone"
                            mask="(000) 000-0000"
                            required
                            />
                        </mat-form-field>
                    </div>
                    <div fxFlex *ngIf="data.actionCd!='remove'">
                        <mat-form-field fxFlex>
                            <mat-label>Street Address</mat-label>
                            <input matInput
                            [(ngModel)]="data.address"
                            name="address"
                            required
                            />
                        </mat-form-field>
                    </div>
                    <div fxFlex fxLayoutAlign="space-around center" fxLayoutGap="1em" *ngIf="data.actionCd!='remove'">
                        <mat-form-field fxFlex>
                            <mat-label>City</mat-label>
                            <input matInput
                            [(ngModel)]="data.city"
                            name="city"
                            required
                            />
                        </mat-form-field>
                        <cad-lib-auto-complete
                            fxFlex="25"
                            placeholder="State"
                            [required]="true"
                            [data]="states"
                            displayProperty="description"
                            resultProperty="code"
                            [sort]="true"
                            [(selectedData)]="data.stateCd">
                        </cad-lib-auto-complete>
                        <mat-form-field fxFlex>
                            <mat-label>Zip</mat-label>
                            <input matInput
                            [(ngModel)]="data.zip"
                            name="zip"
                            required
                            />
                        </mat-form-field>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card *ngIf="data.actionCd!='remove'">
            <mat-card-title>Security Rights</mat-card-title>
            <mat-card-content>
                <b>*Security access levels will be set up for the user only for the pipeline(s) indicated. Please check the appropriate boxes for each pipeline under which the user needs access.</b>
                <div fxLayout="row wrap" fxLayoutGap="5em">
                    <div *ngFor="let asset of assets" class="asset-role-group">
                        <div fxLayout="column" >
                            <b>{{asset.name}}</b>
                            <div fxFlex="fill" *ngFor="let role of asset.roles">
                                <mat-checkbox matInput [name]="role.code" (change)="checkSelected($event, role)" [(ngModel)]="role.checked">{{role.name}}</mat-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
        <mat-card>
            <mat-card-title>Requested By</mat-card-title>
            <mat-card-content>
                <div fxLayout="column">
                    <div fxFlex fxLayoutAlign="space-around center" fxLayoutGap="1em">
                        <mat-form-field fxFlex>
                            <mat-label>Name</mat-label>
                            <input matInput
                            [(ngModel)]="data.managerName"
                            name="managerName"
                            minlength="4"
                            maxlength="60"
                            required
                            />
                        </mat-form-field>
                        <mat-form-field fxFlex>
                            <mat-label>Title</mat-label>
                            <input matInput
                            [(ngModel)]="data.managerTitle"
                            name="managerTitle"
                            required
                            />
                        </mat-form-field>
                    </div>
                    <div fxFlex fxLayoutAlign="space-around center" fxLayoutGap="1em">
                        <mat-form-field fxFlex>
                            <mat-label>Email</mat-label>
                            <input matInput
                            [(ngModel)]="data.managerEmail"
                            name="managerEmail"
                            emailAddress
                            required
                            />
                        </mat-form-field>
                        <mat-form-field fxFlex>
                            <mat-label>Phone</mat-label>
                            <input matInput
                            [(ngModel)]="data.managerPhone"
                            name="managerPhone"
                            mask="(000) 000-0000"
                            required
                            />
                        </mat-form-field>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <mat-card>
        <mat-card-content>
            <div>
                <!-- <re-captcha (resolved)="captchaResolved($event)"></re-captcha> -->
                <!-- <re-captcha [(ngModel)]="captcha" name="captcha" required #captchaControl="ngModel"></re-captcha> -->
                <!-- <re-captcha (resolved)="resolved($event)" (errored)="onError($event)" errorMode="handled"></re-captcha> -->
                <re-captcha id="recaptcha" name="recaptcha" #recaptcha="ngModel" 
                [(ngModel)]="data.recaptchaToken" required 
                [class.is-invalid]="recaptcha.invalid && (recaptcha.dirty || recaptcha.touched)"></re-captcha>
            </div>
            <div fxLayout="row" fxLayoutAlign="left">
                <div fxFlex fxLayoutAlign="start">
                    <button type="submit" mat-raised-button color="primary" [disabled]="submitted || !form.form.valid || recaptcha.invalid || (data.roles.length === 0 && data.actionCd != 'remove')" (click)="submit()">Submit Request</button>
                    <button mat-raised-button (click)="clear()">Clear</button>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
                 
    </form>
    <div class="loading" *ngIf="submitting">
        <mat-spinner></mat-spinner>
    </div>
</div>
<div *ngIf="submitted && !submitting">
    <car-submit-successful [name]="data.firstName" (submitAnother)="clear()"></car-submit-successful>
</div>